import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import TYPES from '../../../config/Types'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import { IConvo } from '../../../model/convo'
import { Meta } from '../../../model/meta'
import { IReference } from '../../../model/reference'

export default async function fetchReferences(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
    convoUtils.convoService.getReferences(convo).then((references: IReference[]) => {
        convoStore.commitSetReferences({ convo: convo, references: references })
    })

    return
}
